export class TextTransformService {

  private static defaultConfig: SeparatorConfig = {
    charsChain: 3,
    separator: ' '
  };

  static separateValues(value: string, separatorConfig?: SeparatorConfig) {
    const config = separatorConfig ? separatorConfig : TextTransformService.defaultConfig;
    let separator = new RegExp(config.separator, 'g');
    let charsChain = config.charsChain;
    let string = '\\B(?=([a-zA-z0-9]{' + charsChain + '})+(?![a-zA-z0-9]))';
    let regExp = new RegExp(string, 'g');

    value = value.replace(separator, '');
    let number = value;
    return number.replace(regExp, config.separator);
  }

  static maskValue(value: any, mask: string, charsToMask: number): string {
    value += '';
    let maskedValue;
    if (value.length <= charsToMask) { // mask all characters
      maskedValue = value.replace(/./g, mask);
    } else {
      const valueCenterIndex = (value.length % 2 === 0) ? (value.length / 2) - 1 : ((value.length - 1) / 2);
      const left = value.slice(0, valueCenterIndex - 1);
      const masked = value.slice(valueCenterIndex - 1, valueCenterIndex - 1 + charsToMask).replace(/./g, mask);
      const right = value.slice(valueCenterIndex - 1 + charsToMask, value.length);
      maskedValue = left + masked + right;
    }

    return maskedValue;
  }

  static capitalize(value: string): string {
    return value.replace(/^\w/, (c) => c.toUpperCase());
  }
}

export interface SeparatorConfig {
  separator: string;
  charsChain: number;
}
